<template>
  <div
    v-if="product"
    class="playlist-toolbar mt-3"
    :class="{
      'container-fluid': showFullActions,
      container: !showFullActions,
    }"
  >
    <div class="row playlist-toolbar-line">
      <div class="col-12">
        <hr class="mt-0 mb-1" />
      </div>
    </div>
    <div class="row playlist-toolbar-content">
      <div class="playlist-toolbar-title">
        <HMTag class="smaller" :title="$t('PRODUCTS.TITLE.PLAYLIST')" />
        <h4 class="m-0 pl-3">{{ product.product_name }}</h4>
      </div>
    </div>
    <div class="row playlist-toolbar-line">
      <div class="col-12">
        <hr class="mt-1 mb-0" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'StudioPlaylistToolbar',
  props: {
    product: {
      type: Object,
    },
    showFullActions: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
.playlist-toolbar.container {
  display: none;
}

.playlist-toolbar.container-fluid {
  display: flex;
  flex-direction: column;
  position: fixed;
  justify-content: space-between;
  bottom: 0;
  width: 100%;
  align-items: stretch;
  z-index: $zindex-fixed + 1;
  background: white;
  min-height: 66px;
  @include media-breakpoint-up(md) {
    position: sticky;
    bottom: initial;
    top: 59px;
    &.container-fluid {
      box-shadow: 0px 2px 4px rgba(50, 50, 50, 0.2);
      .playlist-toolbar-content {
        padding: 0 2.5rem;
      }
      .col-12 {
        padding: 0;
      }
    }
  }
  @include media-breakpoint-down(sm) {
    max-width: 100vw;
    &.container-fluid,
    &.container {
      box-shadow: 0px -1px 5px rgba(50, 50, 50, 0.2);
    }
  }
}

.playlist-toolbar-line {
  .col-12 {
    @include media-breakpoint-down(md) {
      padding: 0;
    }
  }
}

.playlist-toolbar-title {
  display: none;
  align-items: center;
  @include media-breakpoint-up(md) {
    display: flex;
  }
}

.container {
  .playlist-toolbar-title {
    display: none;
  }
}
</style>
